import { useEffect, useState } from "react";

const useInApp = () => {
  const [env, setEnv] = useState<boolean>(false)
  useEffect(  () => {
    window.flutter_inappwebview?.callHandler('flutterInAppWebViewPlatformReady').then(res => {
      setEnv(true)
    })
  }, [])
  return env
}

export default useInApp

export const isInApp = () => Object.prototype.toString.call(window?.flutter_inappwebview?.callHandler) === '[object Function]';
